// extracted by mini-css-extract-plugin
export default {"modal-footer":"disclaimer_modal_modal-footer__Yz8DF","checkbox":"disclaimer_modal_checkbox__4qOyi"};